"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
/**
 * The crux of the middleware. This generator runs in an infinite loop
 * and obtains our middleware configuration and store via the params passed
 * to the next() iterator function. It will update it's internal state and
 * yield a blank ("") string if it is currently fetching a new token.
 * Note: This is not thread safe and intended only for use in the browser.
 */
function fetchToken() {
    var loading, token, error, _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loading = false;
                token = "";
                error = null;
                _loop_1 = function () {
                    var args, config, store_1, attempt, currentAccessToken_1, currentRefreshToken, debug, handleRefreshAccessToken, needsToken, canFetch, hasRefreshToken, refreshToken;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, null];
                            case 1:
                                args = (_a.sent());
                                if (!args) return [3 /*break*/, 3];
                                config = args.config, store_1 = args.store, attempt = args.attempt;
                                currentAccessToken_1 = config.currentAccessToken, currentRefreshToken = config.currentRefreshToken, debug = config.debug, handleRefreshAccessToken = config.handleRefreshAccessToken;
                                token = currentAccessToken_1(store_1);
                                needsToken = helpers_1.isBlank(token) || !helpers_1.validateToken(token);
                                if (!needsToken) {
                                    error = null;
                                }
                                canFetch = !loading && (attempt < 1 || !error);
                                hasRefreshToken = currentRefreshToken
                                    ? typeof currentRefreshToken(store_1) === "string" &&
                                        !helpers_1.isBlank(currentRefreshToken(store_1))
                                    : false;
                                if (canFetch && needsToken) {
                                    if (!hasRefreshToken) {
                                        if (debug) {
                                            // tslint:disable-next-line no-console
                                            console.log("Middleware could not refresh token.");
                                        }
                                        loading = false;
                                        error = new Error("No refresh token is present.");
                                    }
                                    else if (handleRefreshAccessToken && currentRefreshToken) {
                                        if (debug) {
                                            // tslint:disable-next-line no-console
                                            console.log("Middleware attempting to refresh token: " + currentRefreshToken);
                                        }
                                        refreshToken = currentRefreshToken(store_1);
                                        token = "";
                                        error = null;
                                        loading = hasRefreshToken;
                                        handleRefreshAccessToken(refreshToken, store_1)
                                            .then(function () {
                                            token = currentAccessToken_1(store_1);
                                            loading = false;
                                        })
                                            .catch(function (refreshError) {
                                            error = refreshError;
                                            loading = false;
                                        });
                                    }
                                    else {
                                        if (debug) {
                                            // tslint:disable-next-line no-console
                                            console.log("Middleware lacks configuration.");
                                        }
                                        error = new Error("Access token cannot be refreshed due to lack of configuration.");
                                        loading = false;
                                    }
                                }
                                if (debug) {
                                    // tslint:disable-next-line no-console
                                    console.log("Middleware yielded: " + JSON.stringify({
                                        error: error,
                                        loading: loading,
                                        token: token
                                    }));
                                }
                                return [4 /*yield*/, {
                                        error: error,
                                        loading: loading,
                                        token: token
                                    }];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
/**
 * A local instance of our generator function which we'll poll for
 * an available token.
 */
var gen = fetchToken();
gen.next(); // Ensure the generator is now yielding.
/**
 * Recursively polls for a token using recursion and async function
 * calls.
 * @param {FetchArguments} args The optional redux store and middleware configuration.
 * @returns {string} A token value once a value has been obtained.
 */
function getToken(args) {
    var config = args.config;
    return new Promise(function (resolve) {
        var result = gen.next(args).value;
        if (result && result.loading === false) {
            resolve(result);
        }
        else {
            var delay = config.maxDelay || 100;
            if (config.debug) {
                // tslint:disable-next-line no-console
                console.log("Middleware waiting for result. Retrying in " + delay + "ms");
            }
            setTimeout(function () { return resolve(gen.next(args).value); }, delay);
        }
    });
}
/**
 * Recursively polls for a token using recursion and async function
 * calls.
 * @param {FetchArguments} args The optional redux store and middleware configuration.
 * @returns {string} A token value once a value has been obtained.
 */
var checkForToken = function (args) { return __awaiter(_this, void 0, void 0, function () {
    var result, attempt, rest, incrementedArgs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getToken(args)];
            case 1:
                result = _a.sent();
                attempt = args.attempt, rest = __rest(args, ["attempt"]);
                incrementedArgs = __assign({}, rest, { attempt: attempt + 1 });
                return [2 /*return*/, result && !result.loading ? result : checkForToken(incrementedArgs)];
        }
    });
}); };
/**
 * A helper method that creates a promise which performs a flow similar
 * to the middleware. This is useful if you want to replicate the behavior
 * in a different middleware stack (such as the ApolloClient's networkInterface).
 *
 * @param {IConfig} config The middleware configuration.
 * @return {Function}     An async function that returns an accessible access token.
 */
var getAccessToken = function (config) { return function (store) { return __awaiter(_this, void 0, void 0, function () {
    var result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, checkForToken({ config: config, store: store, attempt: 0 })];
            case 1:
                result = _a.sent();
                if (result && result.error) {
                    throw new Error(result.error.message);
                }
                return [2 /*return*/, result ? result.token : null];
            case 2:
                error_1 = _a.sent();
                config.handleAuthenticationError(error_1, store);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
exports.default = getAccessToken;
